const clearGlobalsHtml = (globals) =>
  globals.map((global) => {
    if (global.localeUnaware) return global;

    return {
      ...global,
      html: '',
    };
  });

export default clearGlobalsHtml;
